import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import { FiChevronUp, FiBookOpen } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import { GiHamburgerMenu } from "react-icons/gi";
import { GoRocket } from "react-icons/go";
import {FiMail , FiSmartphone, FiCheck, FiClock, FiUser, FiMonitor, FiRadio, FiDownload, FiVideo} from "react-icons/fi";
import { FaGraduationCap, FaWhatsapp, FaCalendarCheck, FaRunning, FaFacebookSquare, FaStar } from "react-icons/fa";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TestimonialOne from "../blocks/testimonial/TestimonialOne";



class LandingTestimonial extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          Email: ''
        }
        this.openModal = this.openModal.bind(this)
        this.onSubmit = this.onSubmit.bind(this);
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    onSubmit(e) {
        e.preventDefault();
        // this.setState({isOpenEmail: !this.state.isOpenEmail});
        // this.openModalCheckout();
        
        if(this.state.Email == ""){
            return;
        }

        toast.success("Te enviaremos el Ebook por Email pronto, gracias!");

        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {type_email: 'ebook', email: this.state.Email, name: this.state.Name, phone: this.state.Phone, country: this.state.countryCode},)
        .then(res => {
            console.log('ok sent')
        })
    }


    openModal () {
        this.setState({isOpen: true})
    }
    OpenWS(){
        if (window.type_device){
            window.open("https://api.whatsapp.com/send?phone=51936670597&text=Hola%20Dojopy%2C%20informes%20sobre%20el%20BootCamp%20FullStack.%20" + this.state.grupoSelect, '_blank').focus();
        } else {
            window.open("https://web.whatsapp.com/send?phone=51936670597&text=Hola%20Dojopy%2C%20informes%20sobre%20el%20BootCamp%20FullStack.%20" + this.state.grupoSelect, '_blank').focus();
        }
    }
    OpenMeet(){
        window.open("https://calendly.com/dojopy/bootcamp-full-stack", '_blank').focus();
    }
    render(){
        return(
            <React.Fragment>

                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Testimonios Bootcamp Dojopy' urlSeo="/testimonios" />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--130 pb--50 bg_image bg_image--27"  data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center">
                                    <h3 style={{color: 'white'}} className="title pb-1">
                                    Lo Que Nuestros Alumnos Comparten: Sus Historias y Opiniones
                                    </h3>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}




                <>
     <div style={{marginTop: "20px"}} className="section-title service-style--3 text-center mb--25 mb_sm--0 text-center">
                    <h2 className="title">{true ? "Testimonios": "Testimonials"} </h2>
                </div>

                <div className="rn-testimonial-area bg_color--1 ptb--80">
                    <div className="container">
                        <TestimonialOne langUS={this.state.langUS} />
                    </div>
                </div>
    </>



  {/* Start About Area */}
  <div className="about-area ptb--70 bg_color--5">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            
                            <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Judith</h3>
                                        <h3 className="title" style={{color: "orange"}}>⭐ Consiguió Empleo</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/alN6nU5a2Vo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Bladimir</h3>
                                        <h3 className="title" style={{color: "orange"}}>⭐ Consiguió Empleo</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/dDPWdY-S8-0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Tatiana</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/NhOFeo9_rA4?si=_LWhcwSgAOlmF0Od" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Harold Ivan</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/CJWjmlO3_7k?si=0VWDgUmLhp4pyNRg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Stephany</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/330Wxw_z4_0?si=Ms_tnorjQRspKGrw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Ricardo Osorio</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/ZaR2-71Kg9Q?si=pz_7oW3sL6gOP2oG" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Diana</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/gpLkbRA4ZrE?si=UV0v9lnJQn2IdwAA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                            <h3 className="title">Testimonio Paul</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/81xtrnKV9Ss" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}


{/* 
                                <div className="col-md-6 col-12 mt-4 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title pt-4">Testimonio Oscar</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/qtu4qNnBZbI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-4 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title pt-4">Testimonio Andrés</h3>
                                            <div>
                                            <iframe width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/Xxif1Dc_ifQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}




                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area */}





  <div className="about-area ptb--50 bg_color--5">
                    <div className="about-wrapper">
                        <div className="container px-0" style={{width: "90%"}}>
                        




<div style={{backgroundColor: "white", padding: "0", textAlign: "left"}}>






<div className="d-flex my-3" style={{flexDirection: "column", borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
    <div className="d-flex mb-2">
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/dojopy/harold-face.png" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Harold F.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

    </div>
    </div>
  
    <div style={{maxWidth: "500px"}}>
        <video autoPlay width={"100%"} controls muted src="/assets/video/testimonios-2025.mp4"></video>
      </div>
  </div>



<div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/dojopy/019209102.png" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Javier L.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Como estudiante de informática, sentía que me faltaba experiencia práctica para destacar en el mercado laboral. Gracias al bootcamp, pude desarrollar proyectos reales y adquirir habilidades actuales que no enseñan en la universidad. Ahora, mientras termino mis estudios, ya trabajo como Full Stack Developer en una empresa de tecnología, ganando más de $4,000/mes. ¡El bootcamp fue el complemento perfecto para mi carrera!"

      <br/>
      <b>
      – Javier L., estudiante de informática y desarrollador en una empresa de tecnología.

      </b>
      </p>
    </div>
  </div>

  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/team/faces/face_3.webp" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Bladimir G.
        <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>
        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
      
      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Decidí inscribirme en el Bootcamp Developer Full Stack y fue la mejor decisión de mi vida. Ahora tengo la oportunidad de trabajar con importantes empresas y mis ingresos han mejorado significativamente ¡Gracias Dojofullstack, por brindarme una educación de calidad!"
      <br/>
      <b>
         – Bladimir G., ex principiante y ahora Developer en una empresa internacional.
      </b>
      </p>
    </div>
  </div>


  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/team/faces/face_4.webp" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Victor R.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Cuando seguí esta ruta, pasé de vender ropa en línea a ganar $3,000/mes como Developer Full Stack."
      <br/>
      <b>
         – Victor R., ex principiante y ahora Developer en una empresa internacional.
      </b>
      </p>
    </div>
  </div>





  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/team/faces/face_1.webp" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Laura M.
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      "Soy mamá de dos niños y trabajaba como profesora de primaria.
A los 30 años, pensé que era tarde para cambiar de carrera…
¡Hoy trabajo como Full Stack Developer para una empresa alemana
y gano $3,800/mes desde casa! Lo mejor: veo crecer a mis hijos
mientras diseño aplicaciones educativas que usan miles de alumnos."

      <br/>
      <b>
         – Laura M., egresada del programa en 4 meses.

      </b>
      </p>
    </div>
  </div>



  <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "center"}}>
  <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="79px"
    src="/assets/images/dojopy/01920912.png" 
    />
    <div className="ml-2 mt-2">
      <h5 style={{fontStyle: "italic"}} className="my-0">Maria Sanchez
      <FaFacebookSquare style={{marginLeft: "5px", fontSize: "18px", color: "#1877F2"}}/>

        <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
      </h5>
      <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

      <p style={{fontSize: "13px", fontStyle: "italic"}}>
      Siempre pensé que una carrera en tecnología estaba fuera de mi alcance. Sin embargo, el bootcamp no solo me enseñó habilidades técnicas, sino también cómo aplicarlas en el mundo real. Ahora trabajo para una empresa de tecnología educativa y gano más de $2,300/mes. Lo mejor es que puedo trabajar remotamente y pasar tiempo de calidad con mi hijo.

      <br/>
      <b>
         – Maria Sanchez., egresada del programa en 4 meses.

      </b>
      </p>
    </div>
  </div>
  </div>



  <div className="about-us-list row mx-auto mt-4" style={{maxWidth: "900px"}}>
                                <div className="col-12 text-center my-2">
                               
                                <h3 className="text-black"> ¿Tienes PREGUNTAS? </h3>

                                </div>
                                <div className="col-12 px-0" style={{justifyItems: "center"}}>
                                    <h4 className="title text-black" style={{fontStyle: "normal", fontWeight: "normal", textAlign: window.type_device ? "center": "center", fontSize: "18px"}}>
                                    ¡Escríbenos ahora mismo por Whatsapp!
                                    </h4>

                                    <a target="_blank" href='https://api.whatsapp.com/send?phone=51936670597&text=¡Hola! Me gustaría inscribirme en la Beca Parcial Full Stack.'>
                                    <button
                                                    className="btn-grupo-ws mt-2 text-center"
                                                  style={{backgroundColor: "springgreen", color: "black",
                                                  fontFamily: "Poppins,sans-serif", fontSize: "18px", fontWeight: "bold", textTransform: "uppercase"}}>
                                                
                                                <FaWhatsapp style={{marginRight: "5px", fontSize: "25px"}} />
                                               ¡TENGO UNA PREGUNTA!
                                              </button>
                                    </a>
                              
                                </div>

                            </div>




                        </div>
                    </div>
                </div>


                    {/* Start Team Area  */}
  <div className="rn-team-area ptb--100 bg_color--1" id="team" data-aos="fade-right" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title service-style--3 text-center mb--25 mb_sm--0">
                                        <h2 className="title">¿Ya conoces nuestro Bootcamp? </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3" style={{justifyContent: "center"}}>
                                <a className="rn-btn" href="/" style={{fontSize: "18px", padding: "8px"}} onClick={this.DownloadPdf}>
                                <GoRocket style={{fontSize: "18px", marginRight: "10px"}}/>
                                    Visitar Bootcamp
                                </a>
                            </div>
                        </div>
                </div>
                {/* End Team Area  */}



              
                <ToastContainer
                                                    position="bottom-center"
                                                    autoClose={5000}
                                                    />
              

                {/* Start Back To Top */}
                {/* <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div> */}
                {/* End Back To Top */}


                <FooterTwo />

            </React.Fragment>
        )
    }

    async componentDidMount() {
        this.sleep(1000).then(r => {
            document.getElementById('whatsapp').style.display='block';
            }
            )

    }
}
export default LandingTestimonial;
